import client from './client';

const parseTimer = (timer) => {
  if (!timer) {
    return null;
  }
  const startedAt = timer.startedAt || timer.started_at;
  const endsAt = timer.endsAt || timer.ends_at;
  const durationSeconds = timer.durationSeconds ?? timer.duration_seconds;
  return {
    startedAt: startedAt ? new Date(startedAt) : null,
    endsAt: endsAt ? new Date(endsAt) : null,
    durationSeconds: Number.isFinite(durationSeconds)
      ? durationSeconds
      : (startedAt && endsAt
          ? Math.max(0, Math.round((new Date(endsAt) - new Date(startedAt)) / 1000))
          : null),
  };
};

const withTimer = (data) => {
  if (!data) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map((item) => ({ ...item, timer: parseTimer(item.timer) }));
  }
  return { ...data, timer: parseTimer(data.timer) };
};

export const startAssessment = async (payload) => {
  const response = await client.post('/assessments', payload);
  return withTimer(response.data);
};

export const fetchNextQuestion = async (assessmentId) => {
  const response = await client.get(`/assessments/${assessmentId}/next-question`);
  return withTimer(response.data);
};

export const submitAnswer = async (assessmentId, payload) => {
  const response = await client.post(`/assessments/${assessmentId}/answers`, payload);
  return response.data;
};

export const fetchProgress = async (assessmentId) => {
  const response = await client.get(`/assessments/${assessmentId}/progress`);
  return withTimer(response.data);
};

export const fetchTimer = async (assessmentId) => {
  const response = await client.get(`/assessments/${assessmentId}/progress`);
  return parseTimer(response.data?.timer);
};

export const uploadSnapshot = async (assessmentId, snapshot) => {
  const response = await client.post(`/assessments/${assessmentId}/media/image`, snapshot);
  return response.data;
};

export const uploadSelfIntro = async (assessmentId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await client.post(`/assessments/${assessmentId}/media/self-intro`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadDetectionSummary = async (assessmentId, payload) => {
  const response = await client.post(
    `/assessments/${assessmentId}/proctoring/detections`,
    payload
  );
  return response.data;
};
